<template>
  <div>
    <v-col cols="12" style="margin-top: -15px">
      <v-data-table
        :headers="headers"
        :items="listAccHealth"
        :loading="loading"
        class="elevation-1"
        item-key="account"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100],
        }"
      >
        <template v-slot:item.code="{ item }">
          {{ item.code + " - " + item.brand_name }}
        </template>
        <template v-slot:item.health_rating="{ item }">
          <template
            v-if="
              item.account_health.policy_compliance.account_health_rating ==
              'At Risk'
            "
          >
            <v-chip color="yellow">At Risk</v-chip>
          </template>
          <template
            v-if="
              item.account_health.policy_compliance.account_health_rating ==
              'Good'
            "
          >
            <v-chip color="green" dark>Good</v-chip>
          </template>
          <template
            v-if="
              item.account_health.policy_compliance.account_health_rating ==
              'Critical'
            "
          >
            <v-chip color="red" dark>Critical</v-chip>
          </template>
        </template>
        <template v-slot:item.last_sync="{ item }">
          <template v-if="item.account_health.urgent == true">
            <b style="color: red">{{ item.account_health.last_sync }}</b>
          </template>
          <template v-else>
            {{ item.account_health.last_sync }}
          </template>
        </template>
        <template v-slot:item.status="{ item }">
          <template v-if="item.account_health.status == 'Deactivated'">
            <b style="color: red">{{ item.account_health.status }}</b>
          </template>
          <template v-else>
            {{ item.account_health.status }}
          </template>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="primary"
            small
            @click="
              accHealthDetail = item;
              dialogDetail = !dialogDetail;
            "
          >
            DETAIL
          </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <BaseDialog :active.sync="dialogDetail" dialog_name="Account Health Detail">
      <dialogDetailAcc :item="accHealthDetail" />
    </BaseDialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import dialogDetailAcc from "./c-chart-overall-dialog-amz-acc-health.vue";
import BaseDialog from "../../Common/c-base-dialog";
export default {
  name: "AccountHealthReport",

  props: {
    listAccHealth: Array,
  },

  components: {
    dialogDetailAcc,
    BaseDialog,
  },

  data: () => ({
    loading: false,
    dialogDetail: false,
    accHealthDetail: [],
    headers: [
      { text: "Account", value: "account" },
      { text: "Code - Brand Name", value: "code" },
      {
        text: "Order Defect Rate",
        value:
          "account_health.customer_service_performance.order_defect_rate.seller_fulfilled.value",
      },
      {
        text: "Policy Compliance",
        value: "account_health.policy_compliance.product_policies",
      },
      {
        text: "Late Shipment Rate",
        value:
          "account_health.shipping_performance.late_shipment_rate.seller_fulfilled.value",
      },
      {
        text: "Pre-fulfillment Cancel Rate",
        value:
          "account_health.shipping_performance.pre-fulfillment_cancel_rate.seller_fulfilled.value",
      },
      {
        text: "Valid Tracking Rate",
        value:
          "account_health.shipping_performance.valid_tracking_rate.seller_fulfilled.value",
      },
      {
        text: "Account Health Rating",
        value: "health_rating",
      },
      {
        text: "Status",
        value: "status",
      },
      {
        text: "Balance",
        value: "account_health.balance",
      },
      { text: "Last Sync Date", value: "last_sync" },
      { text: "Detail", value: "actions", sortable: false },
    ],
  }),

  created() {
    this.$root.$refs.accHealth = this;
  },

  methods: {
    turnOffDialog() {
      this.dialogDetail = false;
    },

    convertData() {
      var current = moment(new Date());
      for (var i of this.listAccHealth) {
        var a =
          (current - new Date(i.account_health.last_sync)) / (1000 * 3600);

        if (a >= 24) {
          i.account_health["urgent"] = true;
        } else {
          i.account_health["urgent"] = false;
        }

        i.account_health.last_sync = moment(
          i.account_health.last_sync
        ).fromNow();
        i.account_health.policy_compliance["product_policies"] = 0;
        for (var j of i.account_health.policy_compliance.policy_violations) {
          i.account_health.policy_compliance["product_policies"] += parseInt(
            j.value
          );
        }
      }
      console.log("listAccHealth: ", this.listAccHealth);
    },
  },

  async mounted() {
    this.convertData();
  },
};
</script>

<style lang="scss" scoped>
</style>